export default {"src":"/_next/static/media/logo_ring.4969768f.svg","height":216,"width":269};